import React from 'react';
import SectionHeading from '../../SectionHeading';
import Spacing from '../../Spacing';
import Post from '../../Post';

export default function BlogSection({
  data,
  sectionTitle,
  sectionTitleUp,
  subTitle,
  sectionTitleDown,
  sectionSubTitle,
}) {
  return (
    <div className="">
      <SectionHeading
        title={sectionTitle}
        titleUp={sectionTitleUp}
        titleDown={sectionTitleDown}
        subTitle={subTitle}
        center
      />
      <Spacing md="72" lg="50" />
      <div className="gy-4">
          <div className="col-lg-12">
            <Post lightbox />
          </div>
      </div>
    </div>
  );
}
